import { makeStyles } from "@material-ui/styles";

export const useDefaultStyles = makeStyles({
  arrow: {
    "&:before": {
      border: "black",
    },
    color: "black",
    left: "35px",
    marginLeft: "0px !important",
    marginBottom: "10px",
  },
  tooltip: {
    background: "black",
    zIndex: "9999",
    margin: "5px",
    fontFamily: "Poppins",
  },
});
